import React, { useEffect, useState } from 'react';

import { Skeleton } from '@material-ui/lab';
import {
  useUserClassroomMoves,
  userClassroomMovesGenerate,
  userClassroomMovesWarmup
} from 'sdk';

import { ReactComponent as RevisitIcon } from 'pages/Teachers/Home/assets/revisit-icon.svg';

import styles from './styles.module.scss';

const TomorrowsFocus = () => {
  const [isFailed, setIsFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    data: userClassroomMovesData,
    isLoading: isUserClassroomMovesLoading
  } = useUserClassroomMoves();

  const fetchFocusData = async () => {
    setIsLoading(true);
    setIsFailed(false);

    try {
      await userClassroomMovesGenerate();
      setIsLoading(false);
    } catch (error) {
      setIsFailed(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFocusData();
  }, []);

  useEffect(() => {
    userClassroomMovesWarmup();
  }, []);

  return (
    <div className={styles.focusWidget}>
      {isLoading || isUserClassroomMovesLoading ? (
        <div className={styles.loadingState}>
          <Skeleton variant="rect" width="100%" height={180} />
        </div>
      ) : isFailed ? (
        <div className={styles.errorState}>
          <p>Failed to load focus data.</p>
        </div>
      ) : (
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <RevisitIcon className={styles.warningIcon} />
            <span className={styles.headerTitle}>Revisit</span>
          </div>

          <ul className={styles.bulletList}>
            {userClassroomMovesData?.suggested_moves.map((bullet, index) => (
              <li key={index} className={styles.bulletItem}>
                {bullet}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TomorrowsFocus;
